var React = require('react');

function TickCircle2 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M19.29 9.696a1.027 1.027 0 0 0-1.427.007l-5.649 5.53-2.074-2.03a1.024 1.024 0 0 0-1.43-.01.968.968 0 0 0 .002 1.393l2.774 2.717c.394.385 1.028.39 1.432-.005l6.362-6.205a.97.97 0 0 0 .01-1.397z","id":"a"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("use",{"fill":"#38CA73","xlinkHref":"#a","key":0}),React.createElement("circle",{"stroke":"#38CA73","strokeWidth":"2","cx":"13.5","cy":"13.5","r":"12.5","key":1})])]);
}

TickCircle2.defaultProps = {"width":"27","height":"27"};

module.exports = TickCircle2;

TickCircle2.default = TickCircle2;
